<aurora-modal
    [open]="true"
    headline="Error"
    primaryAction="Close"
    (close)="close.emit()">
    <ep-panel panelType="box" [title]="">
        <ep-row>
          <div class="table-responsive" style="margin: 10px">
            <table class="table" style="width: 100%">
              <tr>
                <th></th>
                <th *ngIf="error.objectType">Object Type</th>
                <th *ngIf="error.apiReplyCode">Reply Code</th>
                <th *ngIf="error.errorsToDisplay">Error</th>
                <th *ngIf="error.stack">Stack Trace</th>
                <th *ngIf="error.isAllowedToCopy"></th>
              </tr>
              <tr *ngIf="error">
                <td>
                  <aurora-badge
                    type="text"
                    prominence="low"
                    class="ms-2"
                    [color]="error.type == 'app' ? 'info' : 'warning'"
                  >
                    {{ error.badgeText }}
                  </aurora-badge>
                </td>
                <td *ngIf="error.objectType">{{ error.objectType }}</td>
                <td *ngIf="error.apiReplyCode">{{ error.apiReplyCode }}</td>
                <td>
                  <ng-container *ngIf="error.errorsToDisplay">
                    <ng-container *ngFor="let message of error.errorsToDisplay">
                      <div>{{ message }}</div>
                    </ng-container>
                  </ng-container>
                </td>
                <td *ngIf="error.stack">{{ error.stack }}</td>
                <td style="padding-top: 15px" *ngIf="error.isAllowedToCopy">
                  <aurora-icon-button ngbTooltip="Copy to Clipboard" (click)="copyToClipboard(error)" icon="copy"></aurora-icon-button>
                </td>
              </tr>
              <ng-container *ngIf="errors && errors.length > 0">
                <tr *ngFor="let error of errors">
                  <td>
                    <aurora-badge type="text" prominence="low" color="info" class="ms-2">
                      {{ error.badgeText }}
                    </aurora-badge>
                  </td>
                  <td *ngIf="error.objectType">{{ error.objectType }}</td>
                  <td *ngIf="error.apiReplyCode">{{ error.apiReplyCode }}</td>
                  <td>
                    <ng-container *ngIf="error.errorsToDisplay">
                      <ng-container *ngFor="let message of error.errorsToDisplay">
                        <div>{{ message }}</div>
                      </ng-container>
                    </ng-container>
                  </td>
                  <td *ngIf="error.stack">{{ error.stack }}</td>
                  <td style="padding-top: 15px" *ngIf="error.isAllowedToCopy">
                    <aurora-icon-button ngbTooltip="Copy to Clipboard" (click)="copyToClipboard(error)" icon="copy"></aurora-icon-button>
                  </td>
                </tr>
              </ng-container>
            </table>
          </div>
        </ep-row>
      </ep-panel>

    <div slot="footer">
        <aurora-button id="PrimaryButton" variant="primary" (click)="close.emit()">Close</aurora-button>
    </div>
</aurora-modal>